import isEmail from 'validator/lib/isEmail'
import type { IsEmailOptions } from 'validator/lib/isEmail'

const FIREBASE_EMAIL_OPTIONS: IsEmailOptions = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
}

export const isValidFirebaseEmail = (value?: string | null): boolean => {
  if (!value) {
    return false
  }

  return isEmail(value.trim(), FIREBASE_EMAIL_OPTIONS)
}
